// React Imports
import { Box, useTheme } from '@mui/material';
import type { SVGAttributes } from 'react';

export const CornerMenuSvg = (_props: SVGAttributes<SVGElement>) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        clipPath: 'inset(0px 295px 90px 0)',
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="312" height="122" viewBox="0 0 312 122" fill="none">
        <g filter="url(#filter0_d_370_93445)">
          <mask id="path-1-inside-1_370_93445" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.52051 10.4638L4.32525 4.29638C3.50802 3.32862 4.32525 2 5.72622 2H16H296C302.627 2 308 7.37258 308 14V104C308 110.627 302.627 116 296 116H28C21.3726 116 16 110.627 16 104V27.5882C16 21.4536 13.7429 15.4666 9.52051 10.4638Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.52051 10.4638L4.32525 4.29638C3.50802 3.32862 4.32525 2 5.72622 2H16H296C302.627 2 308 7.37258 308 14V104C308 110.627 302.627 116 296 116H28C21.3726 116 16 110.627 16 104V27.5882C16 21.4536 13.7429 15.4666 9.52051 10.4638Z"
            fill={theme.palette.background.paper}
          />
          <path
            d="M4.32525 4.29638L4.63118 4.03868L4.63086 4.03831L4.32525 4.29638ZM9.52051 10.4638L9.21459 10.7215L9.21483 10.7218L9.52051 10.4638ZM4.01933 4.55408L9.21459 10.7215L9.82644 10.2061L4.63118 4.03868L4.01933 4.55408ZM5.72622 1.6C4.89842 1.6 4.20871 1.99474 3.85272 2.5765C3.49004 3.1692 3.49428 3.93232 4.01964 4.55445L4.63086 4.03831C4.33899 3.69268 4.34324 3.30761 4.5351 2.99406C4.73366 2.66957 5.15305 2.4 5.72622 2.4V1.6ZM16 1.6H5.72622V2.4H16V1.6ZM16 2.4H296V1.6H16V2.4ZM296 2.4C302.406 2.4 307.6 7.5935 307.6 14H308.4C308.4 7.15167 302.848 1.6 296 1.6V2.4ZM307.6 14V104H308.4V14H307.6ZM307.6 104C307.6 110.407 302.406 115.6 296 115.6V116.4C302.848 116.4 308.4 110.848 308.4 104H307.6ZM296 115.6H28V116.4H296V115.6ZM28 115.6C21.5935 115.6 16.4 110.407 16.4 104H15.6C15.6 110.848 21.1517 116.4 28 116.4V115.6ZM16.4 104V27.5882H15.6V104H16.4ZM9.21483 10.7218C13.3804 15.6573 15.6 21.5542 15.6 27.5882H16.4C16.4 21.3531 14.1054 15.276 9.82619 10.2058L9.21483 10.7218Z"
            fill={theme.palette.text.secondary}
            mask="url(#path-1-inside-1_370_93445)"
          />
        </g>
      </svg>
    </Box>
  );
};
